import { ComponentType, ReactNode } from 'react';
import ErrorBoundary from '@/components/ErrorBoundary';

interface GuardedProps<GProps extends { children: ReactNode }> {
  guard: ComponentType<GProps>;
  guardProps: Omit<GProps, 'children'>;
  children: ReactNode;
}

function Guarded<GProps extends { children: ReactNode }>({
  guard: Guard,
  guardProps,
  children,
}: GuardedProps<GProps>) {
  const props = { ...(guardProps ?? {}), children } as GProps;
  return (
    <ErrorBoundary>
      <Guard {...props} />
    </ErrorBoundary>
  );
}

Guarded.displayName = 'Guarded';

export default Guarded;
